import { render } from "./StepClient.vue?vue&type=template&id=a98604c6"
import script from "./StepClient.vue?vue&type=script&lang=js"
export * from "./StepClient.vue?vue&type=script&lang=js"

import "./StepClient.vue?vue&type=style&index=0&id=a98604c6&lang=css"

import exportComponent from "/home/marwin/projects/123parebrise/appointment-module/src-js/frontend-shortcode-appointment-module/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__